(function () {
  function perView() {
    if (window.matchMedia('(min-width: 1100px)').matches) return 3;
    if (window.matchMedia('(min-width: 750px)').matches) return 2;
    return 1;
  }

  function playVideo(video) {
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  }

  // Stop and reload so the video shows its poster (the static preview) again.
  function stopVideo(video) {
    if (video.paused && video.currentTime === 0) return;
    video.pause();
    video.load();
  }

  function stopAll(root) {
    root.querySelectorAll('.how-to-take__card video').forEach(stopVideo);
  }

  // Plays the step videos one after another and loops back to step 1.
  // Hovering or tapping a card jumps the sequence to that step.
  function initSequence(root, reveal) {
    var videos = Array.prototype.slice.call(root.querySelectorAll('.how-to-take__card video'));
    if (!videos.length) return;
    var current = -1;
    var active = false;

    function playStep(i) {
      videos.forEach(function (video, n) {
        if (n !== i) stopVideo(video);
      });
      current = i;
      if (reveal) reveal(i);
      playVideo(videos[i]);
    }

    videos.forEach(function (video, i) {
      video.loop = false;
      video.removeAttribute('loop');
      video.muted = true;
      video.addEventListener('ended', function () {
        if (active && current === i) playStep((i + 1) % videos.length);
      });
      var card = video.closest('.how-to-take__card');
      if (card) {
        card.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'mouse' && active && current !== i) playStep(i);
        });
      }
    });

    function start() {
      if (active) return;
      active = true;
      if (current < 0) playStep(0);
      else playVideo(videos[current]);
    }

    function pause() {
      active = false;
      if (current >= 0) videos[current].pause();
    }

    root.jumpToVideo = function (video) {
      var i = videos.indexOf(video);
      if (i < 0) return;
      active = true;
      playStep(i);
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[entries.length - 1].isIntersecting) start();
        else pause();
      }, { threshold: 0.25 }).observe(root);
    } else {
      start();
    }
  }

  // Touch screens have no hover: a tap on a card restarts the sequence from that step.
  function toggleTapped(root, target) {
    var card = target.closest ? target.closest('.how-to-take__card') : null;
    var video = card ? card.querySelector('video') : null;
    if (video && root.jumpToVideo) root.jumpToVideo(video);
  }

  function initSlider(root) {
    var slider = root.querySelector('.how-to-take__slider');
    var track = root.querySelector('[data-how-to-track]');
    var prevBtn = root.querySelector('[data-how-to-prev]');
    var nextBtn = root.querySelector('[data-how-to-next]');
    if (!slider || !track) return;

    var mobileSlider = !root.classList.contains('how-to-take--no-mobile-slider');
    var index = 0;

    function items() {
      return track.querySelectorAll('.how-to-take__item');
    }

    function gap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    function step() {
      var card = items()[0];
      return card ? card.getBoundingClientRect().width + gap() : 0;
    }

    // How far the track can move before its last card lines up with the
    // right edge of the page content.
    function maxOffset() {
      var list = items();
      var last = list[list.length - 1];
      if (!last) return 0;
      return Math.max(0, last.offsetLeft + last.offsetWidth - slider.clientWidth);
    }

    function go(nextIndex) {
      var view = perView();
      var isStatic = items().length <= view || (view === 1 && !mobileSlider);
      root.classList.toggle('is-static', isStatic);

      var size = step();
      var limit = isStatic ? 0 : maxOffset();
      var pages = size && limit > 1 ? Math.ceil((limit - 1) / size) + 1 : 1;
      var target = Math.max(0, Math.min(nextIndex, pages - 1));
      index = target;

      var offset = Math.min(index * size, limit);
      track.style.transform = offset > 0 ? 'translateX(' + -offset + 'px)' : '';
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index >= pages - 1;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(index + 1);
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(index - 1);
      });
    }

    window.addEventListener('resize', function () {
      go(index);
    });

    go(0);
    return {
      // Slide so the given step is on screen while its video plays.
      reveal: function (i) {
        var item = items()[i];
        if (!item) return;
        var shift = parseFloat((track.style.transform.match(/-?[\d.]+/) || [0])[0]) || 0;
        var left = item.offsetLeft + shift;
        if (left < -1 || left + item.offsetWidth > slider.clientWidth + 1) {
          go(step() ? Math.round(item.offsetLeft / step()) : 0);
        }
      },
      next: function () {
        go(index + 1);
      },
      prev: function () {
        go(index - 1);
      }
    };
  }

  function init(root) {
    if (!root || root.getAttribute('data-how-to-ready') === 'true') return;
    root.setAttribute('data-how-to-ready', 'true');

    var slider = root.hasAttribute('data-how-to-slider') ? initSlider(root) : null;
    initSequence(root, slider ? slider.reveal : null);

    // Swipe to slide; a short touch tap toggles the tapped card's video.
    var track = root.querySelector('.how-to-take__track');
    if (!track) return;
    var startX = 0;
    var pressed = false;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pressed = true;
      startX = event.clientX;
    });
    track.addEventListener('pointerup', function (event) {
      if (!pressed) return;
      pressed = false;
      var delta = event.clientX - startX;
      if (Math.abs(delta) >= 40) {
        if (slider) {
          if (delta < 0) slider.next();
          else slider.prev();
        }
        return;
      }
      if (event.pointerType !== 'mouse' && Math.abs(delta) < 10) toggleTapped(root, event.target);
    });
    track.addEventListener('pointercancel', function () {
      pressed = false;
    });
  }

  function boot(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-section-type="how-to-take"]')) init(context);
    context.querySelectorAll('[data-section-type="how-to-take"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
